import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import {
    ConfirmResponse,
    ConfirmResponseSchema,
} from "../response/RateImportResponse";

const API_VERSION = "v4";

/**
 * Custom hook untuk mengonfirmasi Import Rates -> memicu batch proses di server.
 */
export const useConfirmRateImport = () => {
    return useMutation<ConfirmResponse, unknown, string>({
        mutationFn: async (importId: string) => {
            const response = await privateApi.post(
                `/${API_VERSION}/rate-import/${importId}/confirm`
            );

            return ConfirmResponseSchema.parse(response.data);
        },
    });
};
